export const adap_deposito_mov = (dep, valor) => {

    let obj = {
        tipo: 'Deposito',
        idUsuario: dep.idUsuario,
        codigoUsuario: dep.codigoUsuario,
        fecha: dep.fecha,
        hashString: dep.hashString,
        hash: dep.hash,
        consecutivo: dep.consecutivo,
        nombre: dep.nombre,
        valor: valor ? valor : dep.valor,
        moneda: dep.tipo,
        departamento: 'Adminstracion',
        correo: dep.correo,
        visible: 'Visible',
        img: dep.img,
        detalle: dep.detalle ? dep.detalle : '',
    }



    return obj




}